import React from 'react';

const RichText = ({content, space_after=null}) => (<div className={`rich_text_container container sp-m-${space_after}`}>
    <div className="rich_text" dangerouslySetInnerHTML={{__html: content}}></div>
  </div>);

export default RichText;